var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { SACardContainer, SACardContent } from './card.variant.shared';
export function SACardVariantMinimal(_a) {
    var children = _a.children, height = _a.height, removePadding = _a.removePadding, width = _a.width, rest = __rest(_a, ["children", "height", "removePadding", "width"]);
    return (React.createElement(SACardContainer, __assign({ height: height, width: width }, rest),
        React.createElement(SACardContent, { showHeader: true, removePadding: removePadding }, children)));
}
//# sourceMappingURL=card.variant.minimal.component.js.map